import type { ColumnDef, DataRow } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
import type { ContactTagPresentation } from "../../../../../../../../../_shared/_logic/contact-quality-tags"

export type DefaultAddressPrefill = Partial<Pick<Property, "zip" | "city" | "country">>

export type AddressUnitBadge = {
  id: string
  label: string
  tooltip: string
  color: string
}

export type AddressContactTag = ContactTagPresentation & {
  color: ContactTagPresentation["color"] | string
}

export type AddressRow = DataRow & {
  property: Property | undefined
  links: PropertyCustomer[]
  unitBadges: AddressUnitBadge[]
  contactTags: AddressContactTag[]
}

export type FilterDisplayMode = "compact" | "detailed"

export type AddressFilterValue = {
  search: string
  customerId: string
  unitQuery: string
  unitCount: string
  contactCount: string
  archiveScope: ArchiveScope
}

export type AddressPropertyQuery = {
  organizationId: string
  search?: string
  customerId?: string
  unitQuery?: string
  unitCount?: number
  contactCount?: number
  archiveScope?: ArchiveScope
  offset: number
  limit: number
}

export const ADDRESS_TABLE_PAGE_SIZE = 80

export const addressTableColumns: ColumnDef[] = [
  { id: "address", label: "Liegenschaft", isPrimary: true },
  { id: "unitBadges", label: "Einheiten" },
  { id: "contactTags", label: "Ansprechpartner" },
]
